import React, { createContext, useContext } from 'react';

const LoginPromptContext = createContext(null);

export function LoginPromptProvider({ onRequireLogin, children }) {
  return (
    <LoginPromptContext.Provider value={onRequireLogin}>
      {children}
    </LoginPromptContext.Provider>
  );
}

export function useLoginPrompt() {
  return useContext(LoginPromptContext);
}
